import React, { useState, useRef, KeyboardEvent, useEffect } from 'react'
import styled from 'styled-components'

import { Search } from 'components'

import useClickOutSide from 'hooks/use-click-outside-hooks'

import IconButton from '../Buttons/IconButton'

type Props = {
  setSearchValue: (value: string) => void
  value?: string
  placeholder?: string
}

const AdvTableSearchComponent: React.FC<Props> = (props) => {
  const { setSearchValue, value = '', placeholder = 'search_lbl' } = props

  const [inputValue, setInputValue] = useState<string>(value)
  const [isInputVisible, setIsInputVisible] = useState<boolean>(false)
  const searchBarRef = useRef<HTMLDivElement>(null)

  const showTextInput = () => setIsInputVisible(true)
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => setInputValue(e.target.value)

  useEffect(() => {
    setInputValue(value)
  }, [value])

  const handleKeyPress = (e: KeyboardEvent) => {
    e.stopPropagation()
    const isEnterKey = e.charCode === 13

    if (!isEnterKey) return

    setSearchValue(inputValue)
  }

  const hideTextInput = () => {
    if (inputValue) return
    setIsInputVisible(false)
  }

  const handleClearSearch = () => {
    setInputValue('')
    setSearchValue('')
  }

  useClickOutSide(searchBarRef, () => hideTextInput())

  return (
    <SearchBarWrapper ref={searchBarRef}>
      <InputWrapper className={isInputVisible ? 'show-text-input' : ''}>
        {isInputVisible && (
          <Search
            value={inputValue}
            onChange={handleInputChange}
            onFocus={showTextInput}
            onKeyPress={handleKeyPress}
            onClickIcon={handleClearSearch}
            placeholder={placeholder}
            autoFocus
          />
        )}
      </InputWrapper>
      <IconButtonWrapper className={isInputVisible ? 'hide-icon-button' : ''} onClick={() => showTextInput()}>
        <IconButton icon={['far', 'search']} iconPosition="center" variant="outline" width={40} height={40} />
      </IconButtonWrapper>
    </SearchBarWrapper>
  )
}

export default AdvTableSearchComponent

const InputWrapper = styled.div``
const IconButtonWrapper = styled.div`
  button {
    padding: 0.7em;
  }
`

const SearchBarWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 35px;

  input {
    min-width: 250px;
    padding: 0.5rem 1rem;
  }

  ${InputWrapper} {
    transition: opacity 0.5s;
    display: none;
    opacity: 0;

    &.show-text-input {
      display: block;
      opacity: 1;
      transition: opacity 0.5s;
    }
  }

  ${IconButtonWrapper} {
    transition: opacity 0.5s;
    display: block;
    opacity: 1;

    &.hide-icon-button {
      display: none;
      opacity: 0;
      transition: opacity 0.5s;
    }
  }
`
